<template>
  <TabsTextMediaBlock
    v-bind="
      $ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'tabItems'
      })
    "
  >
    <template
      v-for="(tabItem, index) in item.fields.tabItems"
      :key="tabItem.fields.title ?? tabItem.sys.id"
    >
      <TabPanel
        :uid="tabItem.sys.id"
        :title="tabItem.fields.title"
        :subtitle="tabItem.fields.subtitle"
        :img-src="
          tabItem.fields.image &&
          isMediaType(tabItem.fields.image, 'image') &&
          tabItem.fields.image.fields.image?.fields?.file?.url
            ? buildContentfulImageSrc({
                format: 'webp',
                baseUrl: tabItem.fields.image.fields.image.fields.file.url,
                imageArea: 'center',
                width: 60,
                quality: 60,
                aspectRatio: [1, 1],
                fit: 'pad'
              })
            : undefined
        "
        :active-on-init="index === 0"
        :icon="
          tabItem.fields.tabIcon
            ? {
                name: tabItem.fields.tabIcon,
                scaleFactor: 2.5
              }
            : undefined
        "
      >
        <MappedComponent :item="tabItem.fields.contentSlot" />
      </TabPanel>
    </template>
  </TabsTextMediaBlock>
</template>

<script setup lang="ts">
import {
  TabPanel,
  TabsTextMediaBlock
} from '@hypercodestudio/basler-components';
import type { IContentTabs } from '~~/lib/ContentfulService';
import { isMediaType } from '~/utils/guards/isMediaType';
import { buildContentfulImageSrc } from '~/utils/buildContentfulImageSrc';
const { $ContentfulLivePreview } = useNuxtApp();

interface Props {
  item: IContentTabs;
}
defineProps<Props>();
</script>
